<div
    bigUiHeadingStyle
    [innerHTML]="html"></div>
